export const BODYAPP_LOCALE = 'bodyapp-locale';
